import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import countryMeta from 'src/app/data/country-meta';
import { CountryCode } from 'src/app/models/country-code';

@Component({
  selector: 'country-code-modal',
  templateUrl: './country-code-modal.component.html',
  styleUrls: ['./country-code-modal.component.scss'],
})
export class CountryCodeModalComponent implements OnInit {
  public modal: any; // the modal instance will be initialized by ionic during runtime.
  public countryCodes: CountryCode[];
  public currentHeaderData: any = {
    modalSlotEnd: true,
    title: 'country_code_modal.select_country',
    marl20: true,
    mart4: true,
  };

  constructor(private modalController: ModalController) {}

  ionViewDidEnter() {
    this.countryCodes = countryMeta;
  }

  ngOnInit() {}

  selectCountryCode(item) {
    return this.modalController.dismiss({ ...item });
  }

  filterCountrylist(event) {
    const val = event.target.value;
    if (val && val.trim() !== '') {
      const search = val.toLowerCase();
      this.countryCodes = countryMeta
        .filter(
          (item) =>
            item.name.toLowerCase().indexOf(search) > -1 ||
            item.code.toLowerCase().indexOf(search) > -1 ||
            item.dialCode.indexOf(val) > -1
        )
        .sort((a, b) => a.name.length - b.name.length);
    } else {
      this.countryCodes = countryMeta;
    }
  }

  closeModal() {
    this.modalController.dismiss();
  }
}
